module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"offersReceived":"Offers Received","winners":"Winners","allbids":"All Bids"},"al":{"offersReceived":"Ofertat e marra","winners":"Fituesit","allbids":"Të gjitha"}}')
  delete Component.options._Ctor
}
